import React from "react";
import Modal, { modalStyles as m } from "./Modal";

// Long-press "Current Quantity" popup — mirrors the POS get_Qty_ById dialog.
export default function QtyInfoModal({ info, onClose }) {
  return (
    <Modal title="Product info" onClose={onClose} width={360}>
      <div style={{ fontWeight: 500, color: "var(--ink)", fontSize: 15 }}>Product Name: {info.label}</div>
      <div style={{ marginTop: 8, fontWeight: 500, color: "var(--ink)", fontSize: 15 }}>
        Current Quantity: {info.loading ? "…" : info.error ? "—" : info.quantity}
      </div>
      {info.error && <div style={{ marginTop: 8, color: "#DC2626", fontSize: 13 }}>{info.error}</div>}
      <button style={m.primary} onClick={onClose}>OK</button>
    </Modal>
  );
}
